export const focusOutline = ({ colors, }) => ({
    boxShadow: `${colors.primary} 0 0 0 2px`,
});
//# sourceMappingURL=focusOutline.js.map